import React from 'react'
import Footer from './Footer';
import { Grid } from './FooterStyles';
import NavbarComp from './NavbarComp';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Figure from 'react-bootstrap/Figure';
import Travel from './Travel'
import Mycard from './Mycard';

const Excellence = () => {
    return ( 
        <div className='animated fadeInUp ease-in-quint d-1 a-2' >
<NavbarComp />
<header>
<div className='overlays'>
<h3 className='exe text-white fw-bold offset-1'>Towards A Center of Excellence soon</h3>
<h6 className='exee text-white fw-bold offset-1'>CAPITAL CAMPAIGN 2020 - 2023</h6>
<p className='text-white fw-bold col-10 col-lg-6 offset-1'>
We are blessed by and grateful for the incredible generosity of our members who have enabled us to complete several projects towards a Center of Excellence in Science Education. There is more we want to do to better support today’s AS SALAM model college students. We are looking forward to contribute Towards a  Capital Campaign with the vision to make significant investments in the school  programs and facilities. we still desire to keep the school tuition-free for some students through scolarships. It is only through the generosity of our benefactors that we can make our school a Center of Excellence.
</p>
<a href="#"><button className='btns offset-1'>Give Now</button></a>


</div>
</header>
<div>
<Row>
        <Col className='row-1' sm={6}>
        <h5 className='text-white text-center fw-bold fs-3 mt-4'>An Unwavering Mission</h5>
            <p className='text-white offset-1 col-10 col-g-6'>
            For  years, at the heart and soul of AS SALAM model college is a commitment to developing the fullest potential of every student in learning, faith, and leadership.

The AS SALAM model college old students association (AMCOSA) is made up of old students of the school who make a difference every day. The unwaivering mission of AMCOSA is to foster a lifelong relationship between our alma mater and its old students and to meet the numerous challenges facing the school today while strengthening the sustainability of projects we have embarked on.
            </p>
        </Col>
        
        
        
        <Col className='row-2 overflow-hidden' sm={6}>
    


<Figure>
      <Figure.Image
        width={1000}
        height={400}
        alt="171x180"
        src={require('../video/am3.jpg')}
      />
      
    </Figure>
        </Col>
      </Row>

</div>
<div className='row-3'>
<Row>
<Col >
<a href="#"><button className='btnss offset-1 offset-lg-2 '>Testimonies</button></a>
</Col>


<Col >
<a href="#"><button className='btnss  offset-0 offset-lg-2 '>Programmes</button></a>
</Col>

<Col >
<a href="#"><button className='btnss offset-0 offset-lg-2'>Hall of fame</button></a>
</Col>
</Row>
</div>
<div className='exe-2 text-center'>
  <div className='overlays'>
    <h1 className='text-white'>OUR  PLANS  </h1>
    <details>
  <summary>Maintenance of the Physics, Chemistry and biology Labs </summary>
  <div class="content">
    <p>
    Physical maintenance of the Physics, Chemistry and Biology laboratories, equipment and multimedia systems.
Purchase of reagents, educational videos, books, electronic materials/tutorials and supplies for the laboratories, ICT Center and e-library as well as Insurance to protect the assets.
    </p>
   <Travel  img={'ex1'} />
   
  </div>
</details>
<details>
  <summary>Continous Yearly Gift and scolarships</summary>
  <div class="content">
    <p>
    we  desires to keep the school tuition-free for some students through scolarships.
    </p>
   <Travel img={'sk'} />
   
  </div>
</details>
<details>
  <summary>AMCOSA connect</summary>
  <div class="content">
   
  <p>
    AMCOSA is looking forward to offer offer networking opportunities, which can connect recent graduates with established professionals and help people pursue career changes.
    </p>
    <Travel img={'skl'} />
  </div>
</details>
<details>
  <summary>intellectual development</summary>
  <div class="content">
  <p>
    To organize programs, which inspire and motivate the young students for their intellectual development.
    </p>
    <Travel img={'verr'} />
  </div>
</details>
<details>
  <summary>Employement updates for members</summary>
  <div class="content">
  <p>
    To provide information of employment opportunities and support whatever possible. To undertake or to do all other things, which may include similar corresponding support, correlated, incidental, necessary matters which may be found by the Executive Committee from time to time to be conducive for the achievement of all or any of the objectives stated in above.
    </p>
  
    <Travel img={'ver'} />
  </div>
</details>

</div>
<div className='row-4 mt-4'>
<h2 className='text-center fw-bold'>Our Payment Methods</h2>
<Row>
<Mycard  img={'pay3'}  description={' CHEQUE.......If you prefer, you can  send us a check by mail. Make your checks payable to "AMCOSA".'}  />
<Mycard  img={'pay2'}  description={'BANK TRANSFER.....money tranfers can be made to:  Bank: first Bank Account #: 3161766589 or any executive account'} />
<Mycard   img={'pay1'} description={'GIVING IN CASH......cash can be paid to any of the current executive '} />
</Row>

 </div>
<div>
 <Footer />
</div>
        </div>
        </div>
     );
}
 
export default Excellence;
